import {
	autoinject,
	bindable,
	customElement,
	PLATFORM,
	useView,
} from 'aurelia-framework';

import { Field } from '~/components/field/common/field';
import {
	commonFieldProperties,
	registerComponent,
} from '~/forms/customisation-editor/property-meta';

const componentTagName = 'a-multiline-text';

registerComponent(componentTagName, {
	name: 'Multiline Text',
	requirePath: PLATFORM.moduleName(
		'components/field/common/multiline-text/multiline-text',
	),
	props: commonFieldProperties,
	isSelectable: true,
});

/**
 * Displays the value as text in a box that
 * has a flexible height (not fixed). This field is used for
 * rendering error messages on the transaction-centre page.
 * (as of 2019-07-16)
 */
@autoinject
@customElement(componentTagName)
@useView(PLATFORM.moduleName('./multiline-text.html'))
export class MultilineText extends Field {}
